@if (link) {
  <a rel="nofollow" [routerLink]="[link]" [state]="routerLinkState" class="block w-[inherit]">
    <ng-container *ngTemplateOutlet="pictureTpl"></ng-container>
  </a>
} @else {
  @if (image || fallbackImage || videoId) {
    <picture class="w-[inherit]">
      @for (sourceMediaSize of sourceMediaSizes; track $index; let last = $last) {
        @if (!last) {
          <source
            cldresize
            [sms]="sourceMediaSize"
            [image]="image || fallbackImage"
            [videoId]="videoId"
            [round]="round">
        }
        @if (last) {
          <img class="w-[inherit]" [ngClass]="videoId ? 'border-accent border-[2px] border-spacing-1' : ''"
            cldresize
            [sms]="sourceMediaSize"
            [image]="image || fallbackImage"
            [videoId]="videoId"
            [alt]="title"
            [attr.loading]="lazyload ? 'lazy' : 'eager'"
            [width]="sourceMediaSize.w"
            [height]="sourceMediaSize.h"
            [round]="round"/>
        }
      }
    </picture>
  }
}

<ng-template #pictureTpl>
  @if (image || fallbackImage || videoId) {
    <picture class="w-[inherit]">
      @for (sourceMediaSize of sourceMediaSizes; track $index; let last = $last) {
        @if (!last) {
          <source
            cldresize
            [sms]="sourceMediaSize"
            [image]="image || fallbackImage"
            [videoId]="videoId"
            [round]="round">
        }
        @if (last) {
          <img class="w-[inherit]" [ngClass]="videoId ? 'border-accent border-[2px] border-spacing-1' : ''"
            cldresize
            [sms]="sourceMediaSize"
            [image]="image || fallbackImage"
            [videoId]="videoId"
            [alt]="title"
            [attr.loading]="lazyload ? 'lazy' : 'eager'"
            [width]="sourceMediaSize.w"
            [height]="sourceMediaSize.h"
            [round]="round"/>
        }
      }
    </picture>
  }
</ng-template>
